export const SERVER_BASE_URL = import.meta.env.VITE_SERVER_URL;
export const ENTERPRISE_PORTAL_URL = import.meta.env.VITE_ENTERPRISE_PORTAL_URL;
export const ENTERPRISE_PORTAL_SIGNUP_URL = import.meta.env.VITE_ENTERPRISE_PORTAL_SIGNUP_URL;
export const ENTERPRISE_PORTAL_SIGNIN_URL = import.meta.env.VITE_ENTERPRISE_PORTAL_SIGNIN_URL;